import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material';

import { useAuthLogin } from '@mopla/business-logic';
import { useTranslation } from '@mopla/i18';
import { BottomSlider, DriverLoginForm, NativePageBackground } from '@mopla/ui';
import { useBooleanState } from '@mopla/utils';

import { environment } from '../../../environments/environment';

import { DrawerContent } from './LoginScreen.styles';

export const LoginScreen = () => {
	const navigate = useNavigate();
	const { t } = useTranslation('logIn');
	const [isOpened, setOpened] = useBooleanState();
	const theme = useTheme();

	const { onLogin, errorMessage, authError, validateUser } = useAuthLogin();

	const onClose = () => {
		navigate({ pathname: '/welcome' });
	};

	useEffect(() => {
		/** This lets the opening animation happen */
		setTimeout(() => {
			setOpened();
		});
	}, [setOpened]);

	return (
		<>
			<BottomSlider
				open={isOpened}
				title={t('text.header')}
				onBack={onClose}
				backgroundColor={theme.palette.primary.light}
			>
				<DrawerContent>
					<DriverLoginForm
						onLogin={onLogin}
						authError={authError}
						errorMessage={errorMessage}
						validateUser={validateUser}
						socialLoginMethods={[...environment.allowedSocialLoginMethods]}
						driverApp
					/>
				</DrawerContent>
			</BottomSlider>
			<NativePageBackground bgColor={theme.palette.primary.light} />
		</>
	);
};

export default LoginScreen;
